import openFormCallBackPhone from './openFormCallBackPhone';
import initOffset from '../common/initOffset';

export default function initShowFormCallbackPhone() {
  initOffset(openFormCallBackPhone, '.js-header__show-form-callback-phone');
}
